import { useMedia } from '@features/advancedVideoPlayer/hooks/useMedia';
import { SmartPlayer } from '@features/smartPlayer';
import { Box, Flex, Skeleton } from '@radix-ui/themes';

import { AudioMixerProvider } from '@features/smartPlayer/context/AudioMixerContext';

export const ClipPlayer = () => {
    const { src, media, tracks, isLoading } = useMedia();

    if (isLoading) {
        return (
            <Box flexGrow='1' height='100%'>
                <Skeleton
                    width='100%'
                    style={{
                        aspectRatio: '16/9',
                        borderRadius: 'var(--radius-3)',
                    }}
                />
            </Box>
        );
    }

    if (!src || !media) return null;

    return (
        <Box flexGrow='1' height='100%'>
            <SmartPlayer src={src} media={media}>
                <AudioMixerProvider>
                    <SmartPlayer.Viewport />
                    <SmartPlayer.Error />

                    <SmartPlayer.Toolbar>
                        <SmartPlayer.Timeline tracks={tracks} />

                        <Box
                            style={{
                                display: 'grid',
                                gridTemplateColumns: '1fr auto 1fr',
                                alignItems: 'center',
                                padding: '0 4px',
                            }}
                        >
                            <Flex justify='start'>
                                <SmartPlayer.Timecode />
                            </Flex>

                            <Flex
                                align='center'
                                justify='center'
                                gap='3'
                                style={{ pointerEvents: 'auto' }}
                            >
                                <SmartPlayer.Rewind />
                                <SmartPlayer.FrameNav direction='backward' />
                                <SmartPlayer.PlayPause size='3' />
                                <SmartPlayer.FrameNav direction='forward' />
                                <SmartPlayer.FastForward />
                            </Flex>

                            <Flex
                                gap='4'
                                align='center'
                                justify='end'
                                style={{ pointerEvents: 'auto' }}
                            >
                                <SmartPlayer.AudioTracks />
                                <SmartPlayer.ChannelController />
                                <SmartPlayer.Volume />
                                <SmartPlayer.Fullscreen />
                            </Flex>
                        </Box>
                    </SmartPlayer.Toolbar>
                </AudioMixerProvider>
            </SmartPlayer>
        </Box>
    );
};
